// extracted by mini-css-extract-plugin
export default {"main":"Main-module__main__I9TYl","steps":"Main-module__steps__8I2aD","edit":"Main-module__edit__1xJjW","container":"Main-module__container__nxn5c"};